import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { advisorApi } from '@/features/workspace/api';
import { routes } from '@/lib/routes';
import { useAdvisorText } from '../labels';
import '@/features/doctoral/dp120.css';
interface Entry {
  id: string;
  candidate_id: string;
  candidate_name: string;
  semester?: number;
  status: string;
  readiness?: string;
  filled?: number;
  required?: number;
  risks?: string;
}
export function AdvisorReviewQueuePage({
  kind,
  onClose,
}: {
  kind: 'plans' | 'attestation';
  onClose: () => void;
}) {
  const st = useAdvisorText(),
    navigate = useNavigate();
  const [items, setItems] = useState<Entry[]>([]);
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    void advisorApi
      .module(kind)
      .then((p) => {
        if (!cancelled) setItems(p.items as Entry[]);
      })
      .catch((e) => {
        if (!cancelled) setError(String(e.message));
      });
    return () => {
      cancelled = true;
    };
  }, [kind]);
  return (
    <div className="dp120-root open">
      <div className="dp120-shell">
        <main className="dp120-main">
          <button className="dp120-back" onClick={onClose}>
            ← {st('Назад')}
          </button>
          <h2>{st(kind === 'plans' ? 'Индивидуальные планы' : 'Аттестация')}</h2>
          {error && <p role="alert">{error}</p>}
          {items.map((row) => (
            <article className="dp120-card" key={row.id}>
              <div className="dp120-card-body">
                <h3>{row.candidate_name}</h3>
                <p>
                  {row.semester
                    ? `${st('Семестр')} ${row.semester}`
                    : `${row.filled}/${row.required}`}{' '}
                  · {st(row.status)} {row.risks}
                </p>
                <button
                  className="dp120-mini"
                  onClick={() =>
                    navigate(
                      `${routes.advisor}/doctoral_process?candidate_id=${row.candidate_id}&section=${kind === 'plans' ? 'plan' : 'nird'}`,
                    )
                  }
                >
                  {st('Открыть проверку')}
                </button>
              </div>
            </article>
          ))}
          {!items.length && <p>{st('Нет данных')}</p>}
        </main>
      </div>
    </div>
  );
}
